import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { SalesPopup } from "./components/SalesPopup";
import { Hero } from "./components/sections/Hero";
import { Problem } from "./components/sections/Problem";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Situations } from "./components/sections/Situations";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="23v2tr4ox335x">
      <MetaPixel data-id="element-1" data-mp="3ij63w8owfj7c" />
      <Hero data-id="element-2" data-mp="3ijpc2xoqyt86" />
      <main data-id="element-3" data-mp="3ihuyk4ft23e4">
        <Problem data-id="element-4" data-mp="3mljaezbgzl56" />
        <BeforeAfter data-id="element-5" data-mp="3ml13n8r6loj0" />
        <Situations data-id="element-6" data-mp="3mkhnnxl3da7m" />
        <Volumes data-id="element-7" data-mp="3mjq1fdddwou0" />
        <Tools data-id="element-8" data-mp="3mj6ibtbzzuee" />
        <Bonuses data-id="element-9" data-mp="3rc9hqi3ghy2i" />
        <Offer data-id="element-10" data-mp="3rbrcivytg9ig" />
        <Guarantee data-id="element-11" data-mp="3rdar8i4tqci4" />
        <Testimonials data-id="element-12" data-mp="3rcsulke91w9o" />
        <Author data-id="element-13" data-mp="3relu8fqg3g86" />
        <FAQ data-id="element-14" data-mp="5otf64sd496" />
        <FinalCTA data-id="element-15" data-mp="6htxpd5ixiv" />
      </main>
      <FloatingCTA data-id="element-16" data-mp="5gel8p3rovc" />
      <SalesPopup data-id="element-17" data-mp="82kl3wchwbg" />
    </div>;
}